import axios from 'axios';

import buildPaginationQueryOpts from '@/shared/sort/sorts';

import { IAnalysisHeader } from '@/shared/model/analysis-header.model';
import buildCriteriaQuery from '@/shared/criteria/criterias';

const baseApiUrl = 'api/analysis-headers';

export default class AnalysisHeaderService {
  public find(id: number): Promise<IAnalysisHeader> {
    return new Promise<IAnalysisHeader>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${id}`)
        .then(function(res) {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieve(paginationQuery?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl + `?${buildPaginationQueryOpts(paginationQuery)}`)
        .then(function(res) {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieveByCriteria(paginationQuery?: any, criteriaQuery?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl + `?${buildPaginationQueryOpts(paginationQuery)}${buildCriteriaQuery(criteriaQuery)}`)
        .then(function(res) {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${baseApiUrl}/${id}`)
        .then(function(res) {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public create(entity: IAnalysisHeader): Promise<IAnalysisHeader> {
    return new Promise<IAnalysisHeader>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}`, entity)
        .then(function(res) {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public update(entity: IAnalysisHeader): Promise<IAnalysisHeader> {
    return new Promise<IAnalysisHeader>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}`, entity)
        .then(function(res) {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public getAnalysisHeaderListExport(criteriaQuery?: any): Promise<any> {
    let fileType = 'xlsx';
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl + `/export? ${buildCriteriaQuery(criteriaQuery)}`, {
          responseType: 'arraybuffer'
        })

        .then(function(response) {
          if (!window.navigator.msSaveOrOpenBlob) {
            let filename = response.headers.filename;

            // BLOB NAVIGATOR
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
          } else {
            let filename = response.headers.filename;
            // BLOB FOR EXPLORER 11
            const url = window.navigator.msSaveOrOpenBlob(new Blob([response.data]), filename);
          }
          resolve('success');
        })
        .catch(err => {
          resolve('err: ' + err);
        });
    });
  }

  public downloadTemplate(role): Promise<any> {
    return new Promise<string>((resolve, reject) => {
      axios({
        url: `${baseApiUrl}/downloadTemplate`,
        method: 'GET',
        responseType: 'blob' // important
      })
        .then(function(response) {
          var filename = '';
          if (role === 'FORIA') {
            filename = 'FormatiTemplateAnalisi.zip';
          }
          if (role === 'LAB') {
            filename = 'FormatiTemplateAnalisiLab.zip';
          }
          if (!window.navigator.msSaveOrOpenBlob) {
            console.log('wait');

            // BLOB NAVIGATOR
            const url = window.URL.createObjectURL(new Blob([response.data]));
            var aaaa = new Blob([response.headers]);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
          } else {
            // BLOB FOR EXPLORER 11
            const url = window.navigator.msSaveOrOpenBlob(new Blob([response.data]), filename);
          }
          resolve('success');
        })
        .catch(err => {
          resolve('err: ' + err);
        });
    });
  }

  public downloadTemplate2(): Promise<any> {
    let fileType = '<zip>';
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl + `/downloadTemplate?`, {
          responseType: 'arraybuffer'
        })

        .then(function(response) {
          if (!window.navigator.msSaveOrOpenBlob) {
            console.log('wait');
            let filename = response.headers.filename;

            // BLOB NAVIGATOR
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
          } else {
            let filename = response.headers.filename;
            // BLOB FOR EXPLORER 11
            const url = window.navigator.msSaveOrOpenBlob(new Blob([response.data]), filename);
          }
          resolve('success');
        })
        .catch(err => {
          resolve('err: ' + err);
        });
    });
  }
}
